import { render, staticRenderFns } from "./reportChange.vue?vue&type=template&id=decf64c8&scoped=true&"
import script from "./reportChange.vue?vue&type=script&lang=js&"
export * from "./reportChange.vue?vue&type=script&lang=js&"
import style0 from "./reportChange.vue?vue&type=style&index=0&id=decf64c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "decf64c8",
  null
  
)

export default component.exports